import React, { useState, useEffect } from "react"
import { CaretIcon } from "components/page-components/Icons/small"
import { Link } from "gatsby"

export const DropdownMenuMobile = ({ label, dropdown_menu_items, page }) => {
  const [submenu_dropdown_active, set_submenu_dropdown_active] = useState(false)

  const close_submenu_dropdown = (e) => {
    if (e.target.id !== "submenu-nav-toggle-" + label) {
      set_submenu_dropdown_active(false)
    }
  }

  const toggle_submenu_dropdown = (e) => {
    e.preventDefault()
    set_submenu_dropdown_active(!submenu_dropdown_active)
  }

  useEffect(() => {
    document.body.addEventListener("click", close_submenu_dropdown)
    return () => {
      document.body.removeEventListener("click", close_submenu_dropdown)
    }
  }, []) //eslint-disable-line

  return (
    <div className="has-text-white is-flex" style={{ position: "relative" }}>
      <a
        id={"submenu-nav-toggle-" + label}
        href=" #"
        onClick={toggle_submenu_dropdown}
        className="m-auto"
      >
        <span
          style={{ fontSize: 18, pointerEvents: "none" }}
          className="has-text-white has-text-weight-bold"
        >
          {label}
          <span className="ml-2">
            <CaretIcon
              {...{
                size: 0.8,
                rotation: submenu_dropdown_active ? "up" : "down",
                color: "#FFFFFF",
              }}
            />
          </span>
        </span>
      </a>
      <div
        className={`submenu-dropdown-menu-mobile${
          submenu_dropdown_active ? " is-active" : ""
        }`}
        page={page}
      >
        {dropdown_menu_items.map(
          ({ link, label, additional_classes }, index) => {
            const is_partially_active = ({ isPartiallyCurrent }) => ({
              className: `submenu-dropdown-link-mobile${isPartiallyCurrent ? " is-currently-active" : ""}${!!additional_classes?.[0] ? ` ${additional_classes?.join(" ")}` : ""}`,
            })

            return (
              <Link
                key={`submenu_dropdown_link-${index}`}
                to={link}
                getProps={is_partially_active}
              >
                <span className="header-link">{label}</span>
              </Link>
            )
          }
        )}
      </div>
    </div>
  )
}
